module.exports = __webpack_public_path__ + "img/info_8.962ee8c8.jpeg";